export default "__VITE_ASSET__I7TnYZ5D__"